import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { apiAssessors } from 'helpers/decorators/api'
import { form } from '../../../../helpers/decorators'
import { Checkbox } from '../../../../components/fields'
import { Button } from '../../../../components/misc'
import { get } from 'lodash'

@form({
  disableHook: true,
  dataKey: 'activity',
  stopPropagation: true
})
@apiAssessors()
class AffiliationActivity extends Component {
  static propTypes = {
    activity: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    onUpdateAssessorActivity: PropTypes.func.isRequired
  }

  handleUpdate = fields => {
    const id = get(this.props.activity, 'id')

    const data = { isPublicAvailable: get(fields,`${this.props.id}-publicAvailable`) }

    this.props.onUpdateAssessorActivity(id, data)
  }

  render() {
    const { handleSubmit, pristine, id } = this.props

   return (
            <div>
              <form onSubmit={handleSubmit(this.handleUpdate)}>
                <div className="row" >
                  <div className="col-xs-8 col-md-8">
                    <Checkbox
                      name={`${id}-publicAvailable`}
                      label="I am happy to assess activities for other participants -> if no then you are not listed among assessor."
                      intlKey="label.i_am_happy_to_assess_other_participants_activities"
                    />
                  </div>
                  <div className="col-xs-2 col-md-2">
                    <Button
                      intlKey="button.update"
                      compact
                      disabled={pristine}
                    >
                      Update
                    </Button>
                  </div>
                </div>
              </form>
            </div>)
  }
}

export default AffiliationActivity
